// extracted by mini-css-extract-plugin
export var formContainer = "_lo-0";
export var message = "_lo-1";